module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"hint":"Уведомить по"}}')
  delete Component.options._Ctor
}
